<template>
  <div id="app">
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'app'
}
</script>

<style>
@import './assets/css/index.css';
.main {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue